/**
 * Header theme toggle — cycles Light → Dark → System.
 * Also pulls the user's saved preference once after login (all role headers
 * render this, so it doubles as the post-login sync point).
 */
import React, { useEffect } from "react";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "./ThemeProvider";

const CYCLE = { light: "dark", dark: "system", system: "light" };
const META = {
  light: { Icon: Sun, label: "Light theme" },
  dark: { Icon: Moon, label: "Dark theme" },
  system: { Icon: Monitor, label: "System theme" },
};

export default function ThemeToggle() {
  const { theme, setTheme, syncFromServer } = useTheme();
  useEffect(() => { syncFromServer(); }, [syncFromServer]);
  const { Icon, label } = META[theme] || META.system;
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setTheme(CYCLE[theme] || "light")}
      title={`${label} — click to switch`}
      aria-label={label}
    >
      <Icon size={17} />
    </button>
  );
}
